import React from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/brandlift-project';

import {Button} from 'client/common/components/lego';

import './creative-list.css';

const i18n = I18N.creatives.creativeList;
const b = b_.with('creative-list');

interface LoadMoreBtnProps {
    fetchMore: () => void;
    canFetchMore: boolean;
    isFetchingMore: boolean;
}
export const LoadMoreBtn = ({fetchMore, canFetchMore, isFetchingMore}: LoadMoreBtnProps) => {
    return (
        <div className={b('load-more')}>
            <Button
                size='m'
                view='action'
                onClick={() => fetchMore()}
                progress={isFetchingMore || undefined}
                disabled={!canFetchMore || isFetchingMore}
            >
                {isFetchingMore ? i18n.loadingMoreBtnText : i18n.loadMoreBtnText}
            </Button>
        </div>
    );
};
